export default {"src":"/_next/static/media/retaining-wall.715e9e49.svg","height":108,"width":116,"blurWidth":0,"blurHeight":0};